// 1:1 wrappers around the Withings webservice cohort endpoints.
//
// A cohort groups one-or-more care teams (programs). The ACCESS cohort
// label lives here (`name`), not on the care team. To render a cohort
// title alongside its care teams (see ChooseCareTeamPage), parallel-fetch
// ProgramService.getEnrolled + CohortService.getManaged and join on
// `cohortid`.

import { ws } from '@/lib/wiservice';

export interface CohortData {
  cohortid: string | number;
  name?: string;
  /** Role tags the current user holds on the cohort (admin, …). */
  roles?: string[];
}

interface GetManagedBody {
  cohorts: CohortData[];
}

/**
 * Cohorts the current user manages (any role, not just admin).
 * Mirrors wpc-front `models/Cohort.js getManaged`.
 */
export async function getManaged(): Promise<CohortData[]> {
  const response = await ws<GetManagedBody>('cohort', 'getmanaged', {});
  return response.body.cohorts ?? [];
}
